import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";

export default function AgreeProvisionTextContent(props) {
  const { data, index, organizer, title } = props;

  // 높이 측정 관련 변수 //
  const [height, setHeight] = useState(0);
  const componentRef = useRef(null);

  // 데이터 props 관련 변수 //
  const [id, setId] = useState(0);
  const [isDefault, setIsDefault] = useState(true);
  const [text, setText] = useState('');
  const [provisionTitle, setProvisionTitle] = useState('');

  // 높이 측정 //
  useEffect(() => {
    const handleResize = (entries) => {
      for (let entry of entries) {
        setHeight(entry.contentRect.height);
      }
    };

    const resizeObserver = new ResizeObserver(handleResize);

    if (componentRef.current) {
      resizeObserver.observe(componentRef.current);
    };

    return () => {
      resizeObserver.disconnect();
    };

  }, []);


  // 데이터 분해 세팅 //
  useEffect(() => {
    setId(data.id);
    setIsDefault(data.isDefault);
    setText(data.text);
    setProvisionTitle(data.title);
  }, [data]);


  // Title 핸들링 함수 //
  function RenderTitleItem(props) {
    const { text } = props;

    if (text === "{organizer}") return <Text fontFamily='NotoSansKR-Bold' fontSize={14} color='#6DD49E' hover='default'>{organizer}</Text>
    else if (text === "{title}") return <Text fontFamily='NotoSansKR-Bold' fontSize={14} color='#FF8B48' hover='default'>{title}</Text>
    else return <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#FFFFFF' hover='default'>{text}</Text>
  };

  function renderTitleText(text) {
    const parts = text.split(/(\{title\}|\{organizer\})/g);
    
    return (
      <TextWrapper>
        {
          parts.map((data, index) => (
            <RenderTitleItem text={data} key={'Title-' + index}/>
          ))
        }
      </TextWrapper>
    );
  };
  
  // Content 핸들링 함수 //
  function RenderContentItem(props) {
    const { text } = props;

    if (text === "{organizer}") return <Text fontFamily='NotoSansKR-Bold' fontSize={14} color='#6DD49E' hover='default'>{organizer}</Text>
    else if (text === "{title}") return <Text fontFamily='NotoSansKR-Bold' fontSize={14} color='#FF8B48' hover='default'>{title}</Text>
    else return <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#FFFFFF' hover='default'>{text}</Text>
  };

  function renderContentText(text) {
    const parts = text.split(/(\{title\}|\{organizer\})/g);

    return (
      <TextWrapper>
      {
        parts.map((data, index) => (
          <RenderContentItem text={data} key={'Content-' + index} />
        ))
      }
      </TextWrapper>
    );
  };


  
  return (
    <TopLevelWrapper>
      <ContentWrapper
        ref={componentRef}
        isFirst={index === 0}>

          <TitleTextWrapper>
            {renderTitleText(provisionTitle)}
          </TitleTextWrapper>
          <DivisionLine />
          <HistoryTextWrapper>
            {renderContentText(text)}
          </HistoryTextWrapper>
      </ContentWrapper>
    </TopLevelWrapper>
  );
};


const TopLevelWrapper = styled.div`
  width: 100%;
  height: 100%;
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  width: 100%;
  height: 100%;

  transition: all 0.3s ease-in-out;

  border-top: ${props => props.isFirst ? '0px' : '1px solid #969696'};
`;

const TitleTextWrapper = styled.div`
  display: flex;

  flex-wrap: wrap;

  margin: 0 0 0 0;
  padding: 20px 10px;

  min-width: 148px;
  max-width: 148px;
`;

const HistoryTextWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  margin: 0 0 0 0;
  padding: 20px 10px;

  width: 100%;
`;

const DivisionLine = styled.div`
  display: flex;

  min-width: 1px;
  max-width: 1px;
  height: 100%;

  background-color: #969696;
`;

//####################
//###### TEXT ########
//####################

const TextWrapper = styled.div`
`;

const Text = styled.span`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  :hover {
    cursor: ${props => props.hover};
  }

  white-space: pre-wrap;
`;
